import { jsx } from "react/jsx-runtime";
import { useState, useEffect, createContext, useContext } from "react";
import { useConfig } from "../../../contexts/config-context.js";
import useInitialAppointmentState from "../actions/initial-appointment-state/index.js";
import { initialDefaultState } from "../actions/initial-appointment-state/utils.js";
const AppointmentFieldContext = createContext({
  appointmentState: {},
  setAppointmentState: () => {
  }
});
const AppointmentContextProvider = ({
  appointmentFieldProps,
  children
}) => {
  const { isEditor, isComposer } = useConfig();
  const [appointmentState, setAppointmentState] = useState(
    () => initialDefaultState({
      appointmentFieldProps,
      isEditor,
      isComposer
    })
  );
  const initialAppointmentState = useInitialAppointmentState(
    appointmentFieldProps
  );
  useEffect(() => {
    if (initialAppointmentState) {
      setAppointmentState({ ...appointmentState, ...initialAppointmentState });
    }
  }, [initialAppointmentState]);
  return /* @__PURE__ */ jsx(
    AppointmentFieldContext.Provider,
    {
      value: {
        appointmentFieldProps,
        appointmentState,
        setAppointmentState: (nextState) => {
          return setAppointmentState({ ...appointmentState, ...nextState });
        }
      },
      children
    }
  );
};
const useAppointmentContext = () => useContext(AppointmentFieldContext);
export {
  AppointmentContextProvider,
  useAppointmentContext
};
//# sourceMappingURL=appointment-context.js.map
